import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { forgotPasswordFormSchema } from 'utils/form-validation-schema';
import { InputControlled } from 'components/UI/InputControlled/InputControlled';
import { forgotUserPassword } from 'services/UserAccountService';

export const ForgotPasswordForm = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [retainFocus, setRetainFocus] = useState(false);
  const methods = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(forgotPasswordFormSchema),
  });

  const onSubmitHandler = async (requestPayload) => {
    setIsProcessing(true);
    const response = await forgotUserPassword(requestPayload);

    if (response.SuccessMessage) {
      setSuccessMessage(response.SuccessMessage);
    } else {
      setErrorMessage(response.ErrorMessage);
    }

    setIsProcessing(false);
  };
  const emailAddressOnBlurHandler = () => {
    setRetainFocus(true);
  };
  return (
    <section className="container">
      <div className="row">
        <div className="col-md-8 col-md-offset-1">
          <h2>Forgotten password</h2>
          <p className="large form-intro" data-testid="form-intro">
            To reset your account password, enter your email address below. Follow the instructions
            in the email to reset your account password.
          </p>
        </div>
      </div>
      <FormProvider {...methods}>
        <form
          name="forgotPasswordForm"
          noValidate="novalidate"
          onSubmit={methods.handleSubmit(onSubmitHandler)}
        >
          {successMessage ? (
            <div className="row">
              <div className="col-md-8  col-md-offset-1">
                <div className="callout-row">
                  <div className="callout-container callout-success">
                    <p>{successMessage}</p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="row">
                <div className="col-sm-6 col-md-4 col-md-offset-1">
                  <div className="form-group">
                    <InputControlled
                      type="email"
                      id="emailAddress"
                      labelText="Email address"
                      error={methods.formState.errors.emailAddress}
                      onBlurValueHandler={emailAddressOnBlurHandler}
                      retainFocus={retainFocus}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8 col-md-offset-1">
                  {errorMessage && (
                    <div className="callout-row">
                      <div className="callout-container callout-error">
                        <p>{errorMessage}</p>
                      </div>
                    </div>
                  )}

                  {methods.formState.errors.emailAddress && (
                    <div className="callout-row">
                      <div className="callout-container callout-error">
                        <p>Please complete forgot password form.</p>
                      </div>
                    </div>
                  )}

                  <br />
                  <button type="submit" className="btn btn-primary" data-testid="submit-button">
                    {isProcessing ? 'Processing...' : 'Submit'}
                  </button>
                </div>
              </div>
            </>
          )}
        </form>
      </FormProvider>
    </section>
  );
};
